import { Component, OnInit } from '@angular/core';
import { WebApiObservableService } from 'app/web-api-observable/web-api-observable.service';
import { Http } from '@angular/http';
import { Router } from '@angular/router';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.css']
})
export class MyAccountComponent implements OnInit {
orders:any=[];
userloggedin:any={};
errorMessage=[];
  constructor(private OrderHistory: WebApiObservableService,private router: Router) { }

  ngOnInit() {

  $('.spin').addClass('loading');
  this.userloggedin= JSON.parse(localStorage.getItem('LOGGED_IN_USER'));
    let token=localStorage.getItem('AUTH_TOKEN');
  	this.OrderHistory
  		 .searchorders('/customerorders','customer_id',this.userloggedin.id,token)
            .subscribe(
                result => {this.orders = result.items;
                $('.spin').removeClass('loading');
                },
                error => { 
                $('.spin').removeClass('loading');   
                this.errorMessage = <any>error}
            );
  }

  ViewOrder(orderid){
  	this.router.navigate(["order-view", orderid]);
  }

   OnLogOut(){
    localStorage.clear();
    this.router.navigate(["home"]);
  }

  openAddresses(){
    this.router.navigate(["addresses"]);
  }

  openAccount(){
    this.router.navigate(["edit-account"]);
  }

}



// WEBPACK FOOTER //
// D:/deliverproject/eatasiafood/src/app/my-account/my-account.component.ts